import { APP_CREATE, APP_CREATE_SUCCESS, APP_CREATE_ERROR } from '../actions/apps';

import { apiCreateApp } from '../../api/apps';

const getters = {};

const actions = {
  [APP_CREATE]: ({ commit }, setting) => {
    commit(APP_CREATE);
    var p = apiCreateApp(setting);
    p.then((resp) => {
      commit(APP_CREATE_SUCCESS, resp);
    }).catch((error) => {
      commit(APP_CREATE_ERROR, error);
    });
    return p;
  },
};

const state = {
  appCreateStatus: false,
};

const mutations = {
  [APP_CREATE]: (state) => {
    state.appCreateStatus = 'loading';
  },
  [APP_CREATE_SUCCESS]: (state, resp) => {
    state.appCreateStatus = 'success';
  },
  [APP_CREATE_ERROR]: (state, error) => {
    state.appCreateStatus = 'error';
  },
};

export default {
  getters,
  state,
  actions,
  mutations,
};
